

























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateIgcscollector from "./create-igcscollector.vue";
import EditIgcscollector from './edit-igcscollector.vue';
class PageIgcscollectorRequest extends PageRequest {
  Keyword: string;
  isrent: number; //nullable
  stime: Date;
  etime: Date;
}

 @Component({
        components:{CreateIgcscollector,EditIgcscollector}
    })
export default class Igcscollector extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageIgcscollectorRequest = new PageIgcscollectorRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
      
    return this.$store.state.igcscollectors.list;
  }
  get loading() {
     
    return this.$store.state.igcscollectors.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("igcscollectors/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("igcscollectors/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }

    await this.$store.dispatch({
      type: "igcscollectors/getAll",
      data: this.pagerequest,
    });
    
  }
   async getAreaAll() {
    await this.$store.dispatch({
      type: "igcscollectors/getQAreaAllData",
    });
  }
   
 

  get pageSize() {
    return this.$store.state.igcscollectors.pageSize;
  }
  get totalCount() {
    return this.$store.state.igcscollectors.totalCount;
  }
  get currentPage() {
    return this.$store.state.igcscollectors.currentPage;
  }

  columns = [
     {
     
      title: this.L("编号"),
      key: "id",
    },
    {
      width: 90,
      title: this.L("UserName"),
      key: "login_Name",
    },
     {
      width: 90,
      title: this.L("Name"),
      key: "name",
    },

    {
      title: this.L("VilName"),
      render: (h: any, params: any) => {
        return h("span", params.row.vArea.vilname);
      },
    },
     
    
    {
      title: this.L("CollectorsType"),
      render: (h: any, params: any) => {
           let  coltpe="";
           if(params.row.collector_type=="TYP_COLLECTOR"){

            coltpe="收集";
           }

        return h("span", coltpe);
      },
    },


    {
      
      title: this.L("Phone"),
      key: "phone",
    },
    {
     
      title: this.L("Useraddr"),
      key: "address",
    },
    
   
    {
      width: 100,
      title: this.L("IsINOffice"),
      render: (h: any, params: any) => {
        return h("span", params.row.isINOffice==0 ? this.L("Yes") : this.L("No"));
      },
    },
     {
      width: 100,
      title: this.L("Archive"),
      render: (h: any, params: any) => {
        return h("span", params.row.archive==0 ? this.L("Yes") : this.L("No"));
      },
    },
   
     
    {
      title: this.L("Addtime"),
      key: "create_time",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.create_time).toLocaleString());
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                
                  this.$store.commit("igcscollectors/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteUserConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "igcscollectors/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
   
    this.getAreaAll();
  }
  //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "igcscollectors/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				   
					lt.map((item) => { // 这里修改要下载的字段内容
        
        	  item.isINOffice == 0 ? item.isINOffice = '是' : item.isINOffice == 1 ?  item.isINOffice ='否' : item.isINOffice ='是'
            item.archive == 0 ? item.archive = '是' : item.archive == 1 ?  item.archive ='否' : item.archive ='是'
					  
            
            item.uname='';
               item.vilname='';
           if(item.vArea!=null){
            item.vilname=item.vArea.vilname;
           }     
            
         let  collector_type="";
           if(item.collector_type=="TYP_COLLECTOR"){
              collector_type="收集";
           }
           item.collector_type=collector_type;

            item.create_time=new Date(item.create_time).toLocaleString()
					  return item;
					});
    
					const filterVal = ['id', 'login_Name','name','vilname', 'collector_type', 'phone', 'address', 'isINOffice','archive','create_time'];// 取出要下载的表头字段
					const tHeader = ['编号','登录帐号','名称','小区','收集员类型','联系方式','地址','是否在职','是否存档','创建时间'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '采集员');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

}
